import React, { FunctionComponent } from 'react';
import { TextField } from '@mui/material';

import { humanCase } from '@paragon/utilities';

import { PropertySchema } from '../PropertySchema';

interface Props {
  name: string;
  value: string;
  schema: PropertySchema<string>;
  configuration: any;
}
export const DateTimePropertyComponent: FunctionComponent<Props> = (props) => {
  const date = Date.parse(props.value);
  if (Number.isNaN(date)) {
    return null;
  }

  const options: Intl.DateTimeFormatOptions = {
    hour12: true,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      required={props.schema.configuration.required}
      error={props.schema.configuration.required && props.value === null}
      label={humanCase(props.name)}
      value={new Intl.DateTimeFormat('en-US', options).format(date)}
      disabled={props.schema.configuration.readOnly || props.configuration.disabled}
      onFocus={(event) => event.target.select()}
    />
  );
};
